module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n3n1n2r-5f40f08861f334f48d539ae6cf00f291.svg";